import emailCheck from '../modules/email-check';

const initialize = () => {
    const adminDeleteModal = document.getElementById('adminDeleteModal');
    adminDeleteModal.addEventListener('show.bs.modal', function (event) {
        console.log('adminDeleteModal show');
        const button = $(event.relatedTarget);
        const email = button.data('email');
        const csrf = button.data('csrf');
        const action = button.data('action');
        console.log({
            email,
            csrf,
            action
        });
        const modal = $(this);
        modal.find('#adminDelete').attr('action', action);
        modal.find('#adminDelete [name="accesstoken"]').val(csrf);
        modal.find('#admin').val(email);
    });

    const adminInviteCancelModal = document.getElementById('adminInviteCancelModal');
    adminInviteCancelModal.addEventListener('show.bs.modal', function (event) {
        const button = $(event.relatedTarget);
        const email = button.data('email');
        const action = button.data('action');

        const modal = $(this);
        modal.find('#adminInviteCancel').attr('action', action);
    });

    const inviteBtn = $('#inviteBtn');
    $('#newAdmin').on('input', function () {
        const emailCheckInstance = new emailCheck($(this).val());

        if (emailCheckInstance.isValid()) {
            inviteBtn.removeAttr('disabled');
        } else {
            inviteBtn.attr('disabled', 'disabled');
        }
    });
};

export default initialize;
